import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import MobileLogo from '../../components/Layout/MobileLogo';

/* Страница приглашения: сюда ведёт короткая ссылка, которую ученик отправляет
   другу. Имя пригласившего лежит прямо в адресе — поэтому страница ничего не
   спрашивает у сервера и открывается мгновенно, даже без входа на платформу.
   Главная кнопка открывает чат с куратором с уже набранным сообщением: другу
   остаётся нажать «отправить», а куратор сразу видит, кто кого привёл. */

const CURATOR_TG = 'informatic_artem';

const IcGift = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" rx="1" />
    <line x1="12" y1="22" x2="12" y2="7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" /><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </svg>
);
const IcTg = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 3 2 10.5l6 2.5 2.5 6L14 15l6 6z" /><path d="m8 13 6-4" />
  </svg>
);

export default function ReferralPage() {
  const { who } = useParams();
  const navigate = useNavigate();

  /* В адресе теперь короткий код — имя спрашиваем у сервера. Ссылки старого
     вида, где имя лежало прямо в адресе, продолжают работать: если это не код,
     показываем то, что в адресе. */
  const fromUrl = (() => {
    try { return decodeURIComponent(who || '').replace(/-+/g, ' ').trim(); } catch (e) { return ''; }
  })();
  const looksLikeCode = /^[a-z0-9]{5,12}$/i.test(who || '');
  const [name, setName] = useState(looksLikeCode ? '' : fromUrl);

  useEffect(() => {
    if (!looksLikeCode) return;
    let alive = true;
    api.get(`/public/invite/${who}`)
      .then(r => { if (alive) setName(r?.data?.name || ''); })
      .catch(() => {});
    return () => { alive = false; };
  }, [who, looksLikeCode]);

  const msg = name
    ? `Здравствуйте! Хочу заниматься в ИНФА СОТКЕ. Меня пригласил(а) ${name} — по реферальной программе.`
    : 'Здравствуйте! Хочу заниматься в ИНФА СОТКЕ — по реферальной программе.';
  const tg = `https://t.me/${CURATOR_TG}?text=${encodeURIComponent(msg)}`;

  return (
    <div className="rfp">
      <div className="rfp-brand"><MobileLogo /></div>

      <div className="exam-card ref-card rfp-card">
        <div className="exam-glow ref-glow" />
        <div className="rfp-body">
          <div className="exam-cap"><span className="ref-cap-ic"><IcGift /></span>Приглашение</div>
          <h1 className="exam-title rfp-title">
            {name ? <>Тебя пригласил<br />{name}</> : <>Тебя пригласили в ИНФА СОТКУ</>}
          </h1>
          <p className="rfp-lead">
            Подготовка к ОГЭ и ЕГЭ по информатике: живые вебинары, домашние задания
            с проверкой и пробники с реальными баллами.
          </p>

          <div className="rfp-bonus">
            <span className="rfp-bonus-sum">−500 ₽</span>
            <span className="rfp-bonus-txt">скидка на первый месяц обучения<br />по этому приглашению</span>
          </div>

          <div className="ref-steps rfp-steps">
            <span><i>1</i>Пишешь куратору — сообщение уже готово</span>
            <span><i>2</i>Он отвечает на вопросы и записывает на курс</span>
            <span><i>3</i>Скидка учитывается при первой оплате</span>
          </div>

          <div className="rfp-acts">
            <a className="exam-go rfp-go" href={tg} target="_blank" rel="noopener noreferrer">
              <IcTg />Написать куратору
            </a>
            <button type="button" className="exam-pdf rfp-ghost" onClick={() => navigate('/')}>
              Посмотреть платформу
            </button>
          </div>
        </div>
      </div>

      <div className="rfp-foot">Сообщение куратору откроется уже написанным — останется нажать «отправить»</div>
    </div>
  );
}
